<template>
 <div>
      <!-- <el-button
      @click="daochu"
      type="primary"
      style="background: #f78989; border-color: #f78989; margin-bottom: 20px"
      >导出</el-button
    > -->
    <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
      <el-table-column prop="customerCode" label="下单客户编码"> </el-table-column>
      <el-table-column prop="customerName" label="下单客户名称"> </el-table-column>
      <el-table-column prop="sellType" label="销售类别"> </el-table-column>
      <el-table-column prop="year" label="年度"> </el-table-column>
      <el-table-column prop="season" label="季度"> </el-table-column>
      <el-table-column prop="month" label="月度"> </el-table-column>
      <el-table-column prop="weight" label="重量"> </el-table-column>
      <el-table-column prop="amount" label="总计金额"> </el-table-column>
      <el-table-column prop="zkAmount" label="市场折扣额"> </el-table-column>
      <el-table-column prop="deliveryAmount" label="发货额"> </el-table-column>
      <el-table-column prop="weigthGoalYear" label="年度重量目标"> </el-table-column>
      <el-table-column prop="weigthGoalSeason" label="季度重量目标"> </el-table-column>
      <el-table-column prop="weigthGoalMonth" label="月度重量目标"> </el-table-column>
      <el-table-column prop="amountGoalYear" label="年度金额目标"> </el-table-column>
      <el-table-column prop="amountGoalSeason" label="季度金额目标"> </el-table-column>
      <el-table-column prop="amountGoalMonth" label="月度金额目标"> </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageNo"
      :page-size="pageSize"
      background
      layout="prev, pager, next, jumper"
      :total="rowCount"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  created() {
    this.getList()
  },
      methods:{
        getList() {
          this.$axios
            .postReq("/meide/REST/ajaxReports", {
              postType: "reportOfGetOrder",
              start: this.pageNo,
              limit: this.pageSize
            })
            .then((res) => {
              this.list = res.data;
              this.rowCount = res.rowcount;
            });
        },
        handleCurrentChange(val) {
          this.pageNo = val;
          this.getList();
        },
    //       daochu() {
    // let invoiceSeq = this.$route.params.id;
    //   this.$axios
    //     .postReq("/meide/REST/ajaxOrderExport", {
    //       postType: "exportInvoiceDetail",
    //       invoiceSeq,
    //     })
    //     .then((res) => {
    //       if (res.success == "true") {
    //         let url = res.url;
    //         window.open(url);
    //       } else {
    //         // this.$message.error(res.ErrorText);
    //       }
    //     });
    // },
    },
  data() {
    return {
      list: [],
      pageNo: 1,
      pageSize: 10,
      rowCount: 0,
    };
  },
};
</script>